import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import { forwardRef } from "react";
import * as t from "@rekajs/types";

export const WhatWeDoItemDefinition: ComponentSettingsProps = {
  title: {
    label: "عنوان",
    section: "محتوا",
    type: "string",
    default: "123",
  },
  description: {
    label: "توضیحات",
    section: "محتوا",
    type: "string",
    default: "default description",
  },
};
export interface WhatWeDoItemProps {
  title?: string;
  description?: string;
}

export const WhatWeDoItem = forwardRef<HTMLDivElement, WhatWeDoItemProps>(
  (props, ref) => {
    return (
      <div
        className="w-full h-full pt-8 pb-2 border-[#FF7700] border-b flex items-center justify-start gap-4"
        ref={ref}
      >
        <p className="text-[70px] md:text-[100px] lg:text-[149.24px] text-[#FF7700] font-helvetica rtl:font-dirooz box-content font-[300] leading-[0.85] lg:leading-[126.86px] tracking-[-3.15px] lg:tracking-[-0.045em]">
          {props.title || String(WhatWeDoItemDefinition.title.default)}
        </p>
        <p
          className="font-inter rtl:font-doran text-[12px] lg:text-[16.06px] text-white pb-7"
          style={{
            fontWeight: "400",
            lineHeight: "13.98px",
          }}
        >
          {props.description ||
            String(WhatWeDoItemDefinition.description.default)}
        </p>
      </div>
    );
  },
) as ComponentType<WhatWeDoItemProps>;
WhatWeDoItem.displayName = "WhatWeDoItem";

export const WhatWeDoItemSettings: ComponentSettings = {
  name: "EWhatWeDoItem",
  props: WhatWeDoItemDefinition,
  label: "آیتم درباره ما",
  childrenAllowed: false,
  widgets: {
    label: "آیتم درباره ما",
    template: () =>
      t.componentTemplate({
        component: t.identifier({
          name: "EWhatWeDoItem",
          external: true,
        }),
      }),
  },
};

WhatWeDoItem.componentSettings = WhatWeDoItemSettings;
